import { useDispatch } from 'react-redux'
import { bindActionCreators, createSlice } from '@reduxjs/toolkit'

type initialStateType = {
  userDidSignOut: boolean
}

const initialState: initialStateType = {
  userDidSignOut: false
}

const userSlice = createSlice({
  name: 'userReducer',
  initialState,
  reducers: {
    signOut(state: initialStateType) {
      state.userDidSignOut = true
    }
  }
})

const { reducer } = userSlice

const useUserActions = () => {
  const dispatch = useDispatch()
  return bindActionCreators({ ...userSlice.actions }, dispatch)
}

export { reducer as userReducer, useUserActions }
